import { useNavigate } from "react-router-dom";
import "./CSS/Footer.css";
import logo from "./IMAGES/sapra_logo-removebg-preview 2.png"

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer-container">
      <div className="footer-top">
        
        {/* Left Section */}
        <div className="footer-left">
          <p className="footer-text">
            Be the first to experience new arrivals and curated pieces crafted
            for the discerning minimalist.
          </p>

          <div className="subscribe-box">
            <input
              type="email"
              placeholder="sample@company.com"
            />
            <button>Subscribe</button>
          </div>
        </div>

        {/* Middle Section */}
        <div className="footer-links">
           <div>
      <p onClick={() => navigate("/")}>Home</p>
      <p onClick={() => navigate("/shop")}>Shop</p>
      <p onClick={() => navigate("/about")}>About Us</p>
      <p onClick={() => navigate("/contact")}>Contact</p>
      <p onClick={() => navigate("/privacypolicy")}> Privacy Policy</p>
      <p onClick={() => navigate("/termsconditions")}>Terms & Conditions</p>
      <p onClick={() => navigate("/refundpolicy")}>Refund & Cancellation Policy</p>
      <p onClick={() => navigate("/shippingpolicy")}>Shipping & Delivery Policy</p>
    </div>

          <div>
            <p>Shop All</p>
            <p>Sarees</p>
            <p>Dresses</p>
            <p>Kurti Sets</p>
            <p>Blouse</p>
            <p>Tops</p>
            <p>Kids</p>
          </div>
        </div>

        {/* Right Section */}
        <div className="footer-right">
          <p>Aggarwal Pride, Flat No. D-</p>
          <p>08, Near Surya Hospital,</p>
          <p>1308, Kasba Peth, Pune</p>
          <p>(Municipal Corporation),</p>
          <p>Pune City, Pune, 411011</p>
          <p> <br /></p>
          <p>saprahouseofelan@gmail.com</p>

          <div className="social-icons">
            <a 
  href="https://www.instagram.com/saprahouseofelan?igsh=aWFwMjJncnpydTJq&utm_source=qr" 
  target="_blank" 
  rel="noopener noreferrer"
>
            <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 9C11.204 9 10.4413 9.316 9.87867 9.87867C9.316 10.4413 9 11.204 9 12C9 12.796 9.316 13.5587 9.87867 14.1213C10.4413 14.684 11.204 15 12 15C12.796 15 13.5587 14.684 14.1213 14.1213C14.684 13.5587 15 12.796 15 12C15 11.204 14.684 10.4413 14.1213 9.87867C13.5587 9.316 12.796 9 12 9ZM12 7C13.3267 7 14.5973 7.52667 15.536 8.464C16.4733 9.40267 17 10.6733 17 12C17 13.3267 16.4733 14.5973 15.536 15.536C14.5973 16.4733 13.3267 17 12 17C10.6733 17 9.40267 16.4733 8.464 15.536C7.52667 14.5973 7 13.3267 7 12C7 10.6733 7.52667 9.40267 8.464 8.464C9.40267 7.52667 10.6733 7 12 7ZM18.5 6.75067C18.5 7.08133 18.368 7.4 18.1333 7.63333C17.9 7.868 17.5813 8 17.2507 8C16.9187 8 16.6 7.868 16.3667 7.63333C16.132 7.4 16 7.08133 16 6.75067C16 6.41867 16.132 6.1 16.3667 5.86667C16.6 5.632 16.9187 5.5 17.2507 5.5C17.5813 5.5 17.9 5.632 18.1333 5.86667C18.368 6.1 18.5 6.41867 18.5 6.75067ZM12 4C9.52533 4 9.12133 4.00667 7.97067 4.05733C7.18667 4.09467 6.66133 4.2 6.17333 4.38933C5.764 4.54 5.396 4.78 5.09333 5.09333C4.78 5.396 4.54 5.764 4.38933 6.17333C4.19867 6.66267 4.09467 7.188 4.05733 7.97067C4.00667 9.07467 4 9.46133 4 12C4 14.4733 4.00667 14.8787 4.05733 16.0293C4.09467 16.812 4.2 17.3387 4.38933 17.8267C4.55867 18.2613 4.75867 18.5747 5.09067 18.9067C5.428 19.2413 5.74133 19.4427 6.17067 19.6093C6.66533 19.8 7.19067 19.9067 7.97067 19.9427C9.07467 19.9933 9.46133 20 12 20C14.4733 20 14.8787 19.9933 16.0293 19.9427C16.8107 19.9053 17.3387 19.8 17.8267 19.6107C18.2333 19.46 18.6027 19.22 18.9067 18.9093C19.2427 18.572 19.444 18.2587 19.6093 17.8293C19.8 17.336 19.9067 16.8093 19.9427 16.0293C19.9933 14.9253 20 14.5387 20 12C20 9.52533 19.9933 9.12133 19.9427 7.97067C19.9053 7.18933 19.8 6.66133 19.6093 6.17333C19.46 5.76533 19.2187 5.396 18.9067 5.09333C18.6053 4.78 18.236 4.53867 17.8267 4.38933C17.3373 4.19867 16.8107 4.09467 16.0293 4.05733C14.9253 4.00667 14.5387 4 12 4ZM12 2C14.7173 2 15.056 2.01067 16.1213 2.06C17.1867 2.11067 17.912 2.27733 18.5493 2.52533C19.2107 2.77867 19.7667 3.12267 20.3227 3.67867C20.8307 4.17733 21.224 4.78267 21.4747 5.45067C21.7213 6.08667 21.8907 6.81333 21.94 7.87867C21.9867 8.944 22 9.28267 22 12C22 14.7173 21.9893 15.056 21.94 16.1213C21.8907 17.1867 21.7213 17.912 21.4747 18.5493C21.224 19.2173 20.8307 19.8227 20.3227 20.3227C19.8227 20.8307 19.2173 21.224 18.5493 21.4747C17.9133 21.7213 17.1867 21.8907 16.1213 21.94C15.056 21.9867 14.7173 22 12 22C9.28267 22 8.944 21.9893 7.87867 21.94C6.81333 21.8907 6.088 21.7213 5.45067 21.4747C4.78267 21.224 4.17733 20.8307 3.67867 20.3227C3.16933 19.8227 2.776 19.2173 2.52533 18.5493C2.27733 17.9133 2.11067 17.1867 2.06 16.1213C2.01333 15.056 2 14.7173 2 12C2 9.28267 2.01067 8.944 2.06 7.87867C2.11067 6.812 2.27733 6.088 2.52533 5.45067C2.77467 4.78267 3.16933 4.17733 3.67867 3.67867C4.17733 3.16933 4.78267 2.776 5.45067 2.52533C6.088 2.27733 6.812 2.11067 7.87867 2.06C8.944 2.01333 9.28267 2 12 2Z" fill="#151515"/>
</svg></span>
</a>
 <a 
  href="https://www.facebook.com/share/1AmUNj8NPH/?mibextid=wwXIfr" 
  target="_blank" 
  rel="noopener noreferrer"
>
            <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 2C6.47733 2 2 6.47733 2 12C2 16.9907 5.65733 21.128 10.4387 21.8787V14.8907H7.89733V12H10.4387V9.79733C10.4387 7.29067 11.9293 5.90667 14.2147 5.90667C15.3093 5.90667 16.4533 6.10267 16.4533 6.10267V8.56133H15.1933C13.9507 8.56133 13.5627 9.33333 13.5627 10.124V12H16.336L15.8933 14.8907H13.5627V21.8787C18.3427 21.1293 22 16.9893 22 12C22 6.47733 17.5227 2 12 2Z" fill="#151515"/>
</svg></span>
</a>
 <a 
  href="https://youtube.com/@saprahouseofelan?si=IMN5j7oGuZmO1cu4" 
  target="_blank" 
  rel="noopener noreferrer"
>
             <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M22.876 6.54133C23.376 8.292 23.376 12.0413 23.376 12.0413C23.376 12.0413 23.376 15.7507 22.876 17.5413C22.6253 18.5413 21.8347 19.292 20.876 19.5413C19.084 20 12.0013 20 12.0013 20C12.0013 20 4.87598 20 3.08398 19.5413C2.12532 19.292 1.33465 18.5413 1.08398 17.5413C0.583984 15.7507 0.583984 12.0413 0.583984 12.0413C0.583984 12.0413 0.583984 8.292 1.08398 6.54133C1.33465 5.54133 2.12532 4.75067 3.08398 4.5C4.87598 4 12.0013 4 12.0013 4C12.0013 4 19.084 4 20.876 4.5C21.8347 4.75067 22.6253 5.54133 22.876 6.54133ZM9.66798 15.4173L15.584 12.0413L9.66798 8.66667V15.4173Z" fill="black"/>
</svg></span>
</a>
          </div>
        </div>
      </div>
      <div className="footer-logo">
      <img src={logo} alt="SaPra Logo" />
    </div>
    </footer>
  );
};

export default Footer;